export const TASKS_JSON = `
[
  {
    "id": 1,
    "type": "app",
    "name": "My Shopping App",
    "minimumDeviceAndroidVersion": 19,
    "screens": [
      2,
      3
    ],
    "singletons": [
      309
    ]
  },
  {
    "id": 2,
    "type": "activity",
    "name": "Cart",
    "uiEvents": [
      700,
      701
    ],
    "vms": [
      500
    ],
    "rootView": 20
  },
  {
    "type": "view",
    "name": "Button",
    "id": 8354,
    "bindings": [
      4794
    ],
    "uiActions": [
      4433
    ]
  },
  {
    "id": 3,
    "type": "activity",
    "name": "Brands",
    "uiEvents": [],
    "vms": []
  },
  {
    "type": "view",
    "name": "Category Button List",
    "id": 1030,
    "bindings": [
      3151
    ],
    "childViews": [
      8354
    ]
  },
  {
    "type": "ui-action",
    "name": "Video Clicked",
    "id": 6632
  },
  {
    "id": 105,
    "type": "view",
    "name": "Shop Now Button",
    "uiActions": [
      345
    ]
  },
  {
    "type": "ui-binding",
    "attribute": "visibility&enabled",
    "cases": [
      {
        "case": "cart.ret.items > 0 && !cart.state.preparing",
        "case_value": "yes"
      },
      {
        "case": "else/opts missing",
        "case_value": "no"
      }
    ],
    "id": 9354
  },
  {
    "type": "view",
    "name": "Loading",
    "id": 8458
  },
  {
    "id": 300,
    "type": "ui-event-stream",
    "name": "UI-Events",
    "out": "CartUiEvents"
  },
  {
    "type": "ui-binding",
    "attribute": "buttons",
    "cases": [
      {
        "case": "",
        "case_value": "{Opt<List<CartEmptyButton>>.or emptyList}"
      }
    ],
    "id": 3151
  },
  {
    "type": "view",
    "name": "tbd",
    "id": 9871
  },
  {
    "id": 400,
    "type": "stateChangerOld",
    "name": "Set categories",
    "in": [
      "308"
    ],
    "targets": [
      602
    ],
    "spec": "Set the categories"
  },
  {
    "type": "ui-action",
    "name": "Button Click",
    "id": 4433
  },
  {
    "id": 401,
    "type": "stateChangerOld",
    "name": "Set Product List Launch",
    "in": [
      "310"
    ],
    "targets": [
      603
    ],
    "spec": "Set the list launch"
  },
  {
    "id": 54,
    "type": "screenPart",
    "name": "Empty Cart",
    "view": 51,
    "stateStream": 540
  },
  {
    "id": 540,
    "type": "stream",
    "name": "Empty Cart State",
    "streams": [
      3426
    ],
    "outState": 3400
  },
  {
    "id": 51,
    "type": "view",
    "name": "Empty Cart",
    "states": [
      {
        "id": 1,
        "name": "Empty State",
        "type": 601
      }
    ],
    "childViews": [
      5719,
      105,
      1030
    ],
    "values": [
      {
        "attr": "design-url",
        "value": "https://s3-eu-west-1.amazonaws.com/specdeck-mbb/UCO-Phone-EmptyCart-V1.png"
      }
    ]
  },
  {
    "id": 20,
    "type": "view",
    "name": "Cart Root",
    "childViews": [
      21,
      22
    ]
  },
  {
    "id": 52,
    "type": "view",
    "name": "Filled Cart",
    "childViews": []
  },
  {
    "id": 308,
    "type": "streamOld",
    "name": "Determine categories for gender",
    "in": [
      "309"
    ],
    "out": {
      "type": "stateOld",
      "dataType": "List of Categories"
    },
    "spec": "Map gender to M -> SHOES, JACKETS, SNEAKERS; F -> DRESSES, GLASSES"
  },
  {
    "id": 340,
    "type": "ui-binding",
    "attribute": "text",
    "cases": [
      {
        "case": "cats 1 present",
        "case_value": "cats name"
      },
      {
        "case": "cats 1 absent",
        "case_value": "No text"
      }
    ]
  },
  {
    "id": 500,
    "type": "viewmodel",
    "name": "VM",
    "rootState": 600,
    "streams": [
      308,
      310
    ],
    "stateChangers": [
      400,
      401
    ]
  },
  {
    "id": 21,
    "type": "view",
    "name": "Cart Content",
    "childViewComposition": 23
  },
  {
    "id": 309,
    "type": "stream",
    "name": "Current gender",
    "outState": 3090,
    "spec": "Holds state (BehaviorSubject): Init by loading potentially stored gender from [store and stream to/from disk(401)] or default to WOMEN  .... setting: set state and store to [401]  .... loading: stream state"
  },
  {
    "id": 3090,
    "type": "state",
    "attributes": [
      {
        "id": 1,
        "name": "Gender"
      }
    ],
    "spec": "Holds state (BehaviorSubject): Init by loading potentially stored gender from [store and stream to/from disk(401)] or default to WOMEN  .... setting: set state and store to [401]  .... loading: stream state"
  },
  {
    "id": 341,
    "type": "ui-binding",
    "attribute": "text-color",
    "cases": [
      {
        "case": "cats 1 present",
        "case_value": "black"
      },
      {
        "case": "cats 1 absent",
        "case_value": "red"
      }
    ]
  },
  {
    "id": 22,
    "type": "view",
    "name": "Toolbar",
    "childViews": [
      4315
    ]
  },
  {
    "id": 310,
    "type": "streamOld",
    "name": "Determine path for category",
    "in": [
      "300.1"
    ],
    "out": {
      "type": "event",
      "dataType": "CategoryPath"
    },
    "spec": "Map category to SHOES -> 982734c3294d8h2349d239, n74293872c93, ..."
  },
  {
    "id": 23,
    "type": "view_composition",
    "compType": "alternate",
    "childViews": [
      8458,
      54,
      52
    ],
    "spec": "cartModel.loading => loading\\ncartModel.cartOpt not present => empty\\ncartModel.cartOpt present => filled"
  },
  {
    "type": "view",
    "name": "Tutorial Video Preview",
    "id": 5719,
    "uiActions": [
      6632
    ]
  },
  {
    "id": 344,
    "in": [
      [
        1,
        603
      ]
    ],
    "type": "ui-single-reaction",
    "name": "Launch Product List for (Cat)"
  },
  {
    "id": 600,
    "type": "stateOld",
    "name": "Cart State",
    "children": [
      601
    ]
  },
  {
    "id": 345,
    "in": [
      [
        1,
        602
      ]
    ],
    "out": [
      1
    ],
    "type": "ui-action",
    "name": "Shop Now Clicked"
  },
  {
    "id": 601,
    "type": "stateOld",
    "name": "Empty State",
    "children": [
      602,
      603,
      604
    ]
  },
  {
    "id": 346,
    "in": [
      [
        1,
        602
      ]
    ],
    "out": [
      1
    ],
    "type": "ui-action",
    "name": "Click"
  },
  {
    "id": 602,
    "type": "stateOld",
    "name": "Shopping Buttons",
    "out": {
      "type": "stateOld",
      "dataType": "List of CartEmptyButton"
    },
    "children": [
      604
    ]
  },
  {
    "type": "ui-binding",
    "attribute": "text",
    "cases": [
      {
        "case": "",
        "case_value": "button.categoryName() + Shoppen"
      }
    ],
    "id": 4794
  },
  {
    "type": "view",
    "name": "Delete Menu Icon",
    "id": 4315,
    "bindings": [
      9354
    ]
  },
  {
    "id": 347,
    "in": [
      [
        1,
        602
      ]
    ],
    "out": [
      1
    ],
    "type": "ui-action",
    "name": "Click"
  },
  {
    "id": 603,
    "type": "stateOld",
    "name": "Launch Product List",
    "out": {
      "type": "stateOld",
      "dataType": "CategoryPath"
    }
  },
  {
    "id": 348,
    "in": [
      [
        1,
        602
      ]
    ],
    "out": [
      1
    ],
    "type": "ui-action",
    "name": "Click"
  },
  {
    "id": 604,
    "type": "stateOld",
    "name": "Show Error",
    "out": {
      "name": "Error Message",
      "dataType": "text"
    }
  },
  {
    "id": 700,
    "type": "uiEvent",
    "name": "Button Click For Category",
    "params": [
      "Category"
    ]
  },
  {
    "id": 349,
    "in": [
      [
        1,
        602
      ]
    ],
    "out": [
      1
    ],
    "type": "ui-action",
    "name": "Click"
  },
  {
    "id": 701,
    "type": "uiEvent",
    "name": "Video Clicked",
    "params": []
  },
  {
    "id": 3400,
    "type": "state",
    "attributes": [
      {
        "id": 1,
        "name": "Loading"
      },
      {
        "id": 2,
        "name": "Opt: Error"
      },
      {
        "id": 3,
        "name": "Opt: List<Button>"
      },
      {
        "id": 4,
        "isAction": true,
        "name": "Open Product List"
      }
    ],
    "stateChangers": [
      {
        "event": "Failed",
        "edits": [
          {
            "target": 1,
            "value": "false"
          },
          {
            "target": 2,
            "value": "error"
          },
          {
            "target": 3,
            "value": "-"
          }
        ]
      },
      {
        "event": "Loaded",
        "edits": [
          {
            "target": 1,
            "value": "false"
          },
          {
            "target": 2,
            "value": "-"
          },
          {
            "target": 3,
            "value": "buttons"
          }
        ]
      },
      {
        "event": "Loading",
        "edits": [
          {
            "target": 1,
            "value": "true"
          },
          {
            "target": 2,
            "value": "-"
          },
          {
            "target": 3,
            "value": "-"
          }
        ]
      }
    ]
  },
  {
    "id": 3426,
    "type": "stream",
    "name": "Load Button Info",
    "spec": "This is loading bla bla bla form the API",
    "outSignal": 3427
  },
  {
    "id": 3427,
    "type": "signalGroup",
    "variants": [
      {
        "id": 3427,
        "name": "Loading"
      },
      {
        "id": 3428,
        "name": "Loaded",
        "attributes": [
          {
            "name": "List ButtonSpec",
            "typeId": 1234
          }
        ]
      },
      {
        "id": 3429,
        "name": "Failed",
        "attributes": [
          {
            "name": "Error",
            "typeId": 1235
          }
        ]
      }
    ]
  }
]
`;



// WEBPACK FOOTER //
// ./src/tasks.js